import { __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { Menu } from '../Menu/Menu.js';
import '../Button/Button.js';
import '../Button/ButtonBase/index.js';
import '../Button/ButtonBody/index.js';
import '../Dropdown/DropdownProvider.js';
import '../hooks/useDetectInputMethod.js';
import '../Menu/MenuContext/MenuProvider.js';
import '../IconButton/IconButton.js';
import 'react/jsx-runtime';
import '@emotion/react';
import 'lodash.get';
import '@compono/ui-theme';
import 'deepmerge';
import '@emotion/is-prop-valid';
import '../Box/index.js';
import 'react';
import '@reach/auto-id';
import '../Link/LinkButton/index.js';
import 'react-focus-lock';
import '@reach/rect';
import '../Popover/Popover.js';
import 'tabbable';
import '@reach/utils';
import '../SelectLegacy/MultiLevelSelectLegacy/MultiLevelSelectLegacy.js';
import '../SelectLegacy/MultiLevelSelectLegacy/MultiLevelSelectLegacyBackButton.js';
import '../SelectLegacy/MultiLevelSelectLegacy/MultiLevelSelectLegacyButton.js';
import '../SelectLegacy/MultiLevelSelectLegacy/MultiLevelSelectLegacyDropdown.js';
import '../SelectLegacy/MultiLevelSelectLegacy/MultiLevelSelectLegacyOptions.js';

var DatePickerMenu = function (props) {
    return jsx(Menu, __assign({}, props));
};

export { DatePickerMenu };
//# sourceMappingURL=DatePickerMenu.js.map
